import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subscription } from 'rxjs';
import { PermissionHelper } from 'app/core/utils/permission.helper';

@Directive({
  selector: '[appHasRight]',
})
export class HasRightDirective implements OnInit, OnDestroy {
  private currentUser;
  private rights: number[];
  private getUserDataSubscription: Subscription;
  private elseTemplateRef: TemplateRef<any> | null = null;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private oidcSecurityService: OidcSecurityService,
  ) {}

  ngOnInit() {
    this.getUserDataSubscription = this.oidcSecurityService.userData$.subscribe((userData: any) => {
      // Handle the nested structure - actual user data is in userData.userData
      this.currentUser = userData?.userData;
      this.updateView();
    });
  }

  ngOnDestroy() {
    if (this.getUserDataSubscription) {
      this.getUserDataSubscription.unsubscribe();
    }
  }

  @Input()
  set appHasRight(val) {
    this.rights = val;
    this.updateView();
  }

  @Input()
  set appHasRightElse(templateRef: TemplateRef<any> | null) {
    this.elseTemplateRef = templateRef;
    this.updateView();
  }

  private updateView() {
    this.viewContainer.clear();
    if (this.checkPermission()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (this.elseTemplateRef) {
      this.viewContainer.createEmbeddedView(this.elseTemplateRef);
    }
  }
  
  private checkPermission() {
    return PermissionHelper.hasAnyRight(this.currentUser, this.rights);
  }
}
